/**
 * World Courier booking UI (Shipments → Book new shipment).
 * The backend exposes the company capability in the JWT. Keep this helper
 * name for compatibility with existing EL/CL call sites.
 */
export const WORLD_COURIER_TRANSPORT_PROVIDER_ID = 'WORLD_COURIER';

/** EL/CL and WC-style UI — gated by the JWT company capability flag. */
export function isWorldCourierCompany(
  enableCustomerLeg: boolean | null | undefined
): boolean {
  return Boolean(enableCustomerLeg);
}

/**
 * Companies allowed to use World Courier booking regardless of enablecustomerleg.
 * Kept separate from the EL/CL flag so booking can be granted without enabling
 * customer/execution leg UI.
 */
export const WORLD_COURIER_BOOKING_ALLOWED_COMPANY_IDS = new Set<string>([
  '22a3e579-3a38-4596-b725-b05a6f71ec85', // Minaris
  '95b618d1-75c8-4323-ba8e-e0af61261132',
  'fa0e11b7-8eda-41a5-94ca-4a59515b9388',
]);

/** Returns true if the company may see the World Courier booking option. */
export function canBookWorldCourier(
  companyId: string | null | undefined
): boolean {
  if (!companyId) return false;
  return WORLD_COURIER_BOOKING_ALLOWED_COMPANY_IDS.has(companyId);
}
